/* Thalise surface behaviors — spec §2.1 (kart medya noktaları) & §3.1 (fraction mikro-motion).
   Kasıtlı olarak küçük tutuldu: scroll-snap native, burada yalnız göstergeler. */
(function () {
  'use strict';

  /* 1) Kart medya noktaları — scroll bubble olmadığından capture fazında dinle */
  var ticking = false;
  document.addEventListener(
    'scroll',
    function (e) {
      var t = e.target;
      if (!t || !t.classList || !t.classList.contains('thalise-card-media__track')) return;
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var dots = t.parentElement && t.parentElement.querySelector('.thalise-card-media__dots');
        if (!dots) return;
        var i = Math.max(0, Math.round(t.scrollLeft / Math.max(t.clientWidth, 1)));
        var slides = t.querySelectorAll('.thalise-card-media__slide');
        for (var k = 0; k < dots.children.length; k++) {
          var isActive = (k === i);
          dots.children[k].classList.toggle('is-active', isActive);
          if (slides[k]) {
            var vid = slides[k].querySelector('video');
            if (vid) {
              if (isActive) {
                vid.play().catch(function () {});
              } else {
                vid.pause();
              }
            }
          }
        }
      });
    },
    { passive: true, capture: true }
  );

  /* 2) PDP galeri nokta rayı — native fraction sayacından senkron (M2 revizyonu) */
  function buildGalleryDots() {
    document.querySelectorAll('hdt-product-media').forEach(function (pm) {
      var counter = pm.querySelector('hdt-slider-counter');
      if (!counter || pm.querySelector('.thalise-gallery-dots')) return;
      var nums = counter.textContent.match(/\d+/g) || [];
      var total = parseInt(nums[1], 10);
      if (!total || total < 2) return;
      var slider = pm.querySelector('hdt-slider');
      var rail = document.createElement('div');
      rail.className = 'thalise-gallery-dots';
      for (var i = 0; i < total; i++) {
        var d = document.createElement('i');
        if (i === 0) d.className = 'is-active';
        rail.appendChild(d);
      }
      if (slider) slider.insertAdjacentElement('afterend', rail);
      else pm.appendChild(rail);
      new MutationObserver(function () {
        var n = counter.textContent.match(/\d+/g) || [];
        var idx = parseInt(n[0], 10);
        if (!isNaN(idx)) {
          for (var k = 0; k < rail.children.length; k++) {
            rail.children[k].classList.toggle('is-active', k === idx - 1);
          }
        }
      }).observe(counter, { characterData: true, childList: true, subtree: true });
    });
  }

  /* 3) PDP fraction sayaç — değerin değişiminde 150-250ms fade/slide (desktop) */
  function watchCounter(el) {
    if (!el || el.__thaliseWatched) return;
    el.__thaliseWatched = true;
    var text = el.textContent;
    new MutationObserver(function () {
      if (el.textContent === text) return;
      text = el.textContent;
      el.classList.remove('is-tick');
      void el.offsetWidth;
      el.classList.add('is-tick');
    }).observe(el, { characterData: true, childList: true, subtree: true });
  }
  /* 4) Kart videoları — viewport içine girdiğinde aktif slayt videosunu oynat */
  function observeVideos() {
    if (!('IntersectionObserver' in window)) return;
    if (!window.__thaliseVideoObs) {
      window.__thaliseVideoObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          var slide = video.closest('.thalise-card-media__slide');
          var track = video.closest('.thalise-card-media__track');
          if (entry.isIntersecting) {
            if (track && slide) {
              var activeIdx = Math.max(0, Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)));
              var slides = Array.from(track.querySelectorAll('.thalise-card-media__slide'));
              if (slides.indexOf(slide) === activeIdx) {
                video.play().catch(function () {});
              }
            } else {
              video.play().catch(function () {});
            }
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.2 });
    }
    document.querySelectorAll('.thalise-card-video').forEach(function (v) {
      if (!v.__thaliseObserved) {
        v.__thaliseObserved = true;
        window.__thaliseVideoObs.observe(v);
      }
    });
  }

  /* 5) Kart kaydırma jestleri — swipe sırasında kazara PDP'ye tıklanmasını önle */
  document.addEventListener('touchstart', function (e) {
    var track = e.target.closest && e.target.closest('.thalise-card-media__track');
    if (!track) return;
    track._startX = e.touches[0].clientX;
    track._startY = e.touches[0].clientY;
    track._isDragging = false;
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    var track = e.target.closest && e.target.closest('.thalise-card-media__track');
    if (!track || track._startX == null) return;
    var dx = Math.abs(e.touches[0].clientX - track._startX);
    var dy = Math.abs(e.touches[0].clientY - track._startY);
    if (dx > 10 && dx > dy) {
      track._isDragging = true;
    }
  }, { passive: true });

  document.addEventListener('click', function (e) {
    var track = e.target.closest && e.target.closest('.thalise-card-media__track');
    if (track && track._isDragging) {
      e.preventDefault();
      e.stopPropagation();
      track._isDragging = false;
    }
  }, true);

  /* 6) Koleksiyon İlk Kart Swipe Cue Animasyonu (Oner Active Benchmark) */
  function triggerSwipeCue() {
    var firstTrack = document.querySelector('.thalise-card-media__track');
    if (!firstTrack || firstTrack._cueAttached) return;
    firstTrack._cueAttached = true;

    var slides = firstTrack.querySelectorAll('.thalise-card-media__slide');
    if (slides.length < 2) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !firstTrack._cueDone) {
            firstTrack._cueDone = true;
            observer.disconnect();
            setTimeout(function () {
              firstTrack.scrollTo({ left: 45, behavior: 'smooth' });
              setTimeout(function () {
                firstTrack.scrollTo({ left: 0, behavior: 'smooth' });
              }, 400);
            }, 300);
          }
        });
      }, { threshold: 0.3 });
      observer.observe(firstTrack);
    }
  }

  /* 7) Sepet İçi Hızlı Beden Seçim Modalı (CSB Benchmark) */
  function initCartQuickAdd() {
    var sheet = document.getElementById('thalise-cart-quickadd-sheet');
    if (!sheet || sheet._initialized) return;
    sheet._initialized = true;

    var closeBtn = sheet.querySelector('.thalise-quickadd__close');
    var backdrop = sheet.querySelector('.thalise-quickadd__backdrop');
    var imgEl = sheet.querySelector('.thalise-quickadd__img');
    var titleEl = sheet.querySelector('.thalise-quickadd__title');
    var priceEl = sheet.querySelector('.thalise-quickadd__price');
    var sizeLabel = sheet.querySelector('.thalise-quickadd__selected-size');
    var pillsContainer = sheet.querySelector('.thalise-quickadd__pills');
    var submitBtn = sheet.querySelector('.thalise-quickadd__btn-submit');
    var submitText = sheet.querySelector('.thalise-quickadd__btn-text');
    var submitSpinner = sheet.querySelector('.thalise-quickadd__btn-spinner');

    var selectedVariantId = null;

    function closeSheet() {
      sheet.classList.remove('is-open');
      sheet.setAttribute('aria-hidden', 'true');
      selectedVariantId = null;
    }

    if (closeBtn) closeBtn.addEventListener('click', closeSheet);
    if (backdrop) backdrop.addEventListener('click', closeSheet);

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.thalise-cart-upsell-btn');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var variantsRaw = btn.getAttribute('data-variants');
      var variants = [];
      try {
        variants = JSON.parse(variantsRaw || '[]');
      } catch (err) {}

      var title = btn.getAttribute('data-product-title') || '';
      var price = btn.getAttribute('data-product-price') || '';
      var img = btn.getAttribute('data-product-image') || '';

      if (variants.length === 1 && variants[0].available) {
        addVariantToCart(variants[0].id, btn, false);
        return;
      }

      if (imgEl) imgEl.src = img;
      if (titleEl) titleEl.textContent = title;
      if (priceEl) priceEl.textContent = price;
      if (sizeLabel) sizeLabel.textContent = '-';
      if (submitBtn) submitBtn.disabled = true;

      if (pillsContainer) {
        pillsContainer.innerHTML = '';
        variants.forEach(function (v) {
          var pill = document.createElement('button');
          pill.type = 'button';
          pill.className = 'thalise-size-pill' + (v.available ? '' : ' is-soldout');
          pill.textContent = v.title;
          pill.disabled = !v.available;

          if (v.available) {
            pill.addEventListener('click', function () {
              pillsContainer.querySelectorAll('.thalise-size-pill').forEach(function (p) {
                p.classList.remove('is-selected');
              });
              pill.classList.add('is-selected');
              selectedVariantId = v.id;
              if (sizeLabel) sizeLabel.textContent = v.title;
              if (submitBtn) submitBtn.disabled = false;
            });
          }
          pillsContainer.appendChild(pill);
        });
      }

      sheet.classList.add('is-open');
      sheet.setAttribute('aria-hidden', 'false');
    });

    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        if (!selectedVariantId) return;
        addVariantToCart(selectedVariantId, submitBtn, true);
      });
    }

    function addVariantToCart(variantId, triggerBtn, isSheet) {
      if (isSheet) {
        if (submitBtn) submitBtn.disabled = true;
        if (submitText) submitText.hidden = true;
        if (submitSpinner) submitSpinner.hidden = false;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        if (isSheet) {
          if (submitText) submitText.hidden = false;
          if (submitSpinner) submitSpinner.hidden = true;
          closeSheet();
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:reload', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
        var cartDrawer = document.querySelector('hdt-cart-drawer');
        if (cartDrawer && typeof cartDrawer.render === 'function') {
          cartDrawer.render();
        } else {
          window.location.reload();
        }
      })
      .catch(function (err) {
        console.error('Cart add error:', err);
        if (isSheet) {
          if (submitBtn) submitBtn.disabled = false;
          if (submitText) submitText.hidden = false;
          if (submitSpinner) submitSpinner.hidden = true;
        }
      });
    }
  }

  function scanCounters() {
    document.querySelectorAll('hdt-slider-counter').forEach(watchCounter);
    buildGalleryDots();
    observeVideos();
    triggerSwipeCue();
    initCartQuickAdd();
  }

  var scanTimer = null;
  function debouncedScan() {
    if (scanTimer) clearTimeout(scanTimer);
    scanTimer = setTimeout(function () {
      requestAnimationFrame(scanCounters);
    }, 150);
  }

  var mainContent = document.getElementById('MainContent') || document.body;
  if (mainContent && window.MutationObserver) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length > 0) {
          debouncedScan();
          break;
        }
      }
    }).observe(mainContent, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanCounters);
  } else {
    scanCounters();
  }
  document.addEventListener('shopify:section:load', scanCounters);
  document.addEventListener('shopify:section:select', scanCounters);
})();
